import { LIST_PAGES_QUERY, ListPagesData } from '../../queries';
import { MutationHookOptions, useMutation } from 'react-apollo';
import { DELETE_PAGE_MUTATION } from './delete-page-mutation';
import { DeletePagePayload } from './delete-page-payload';
import { DeletePageVariables } from './delete-page-variables';
import { MutationUpdaterFn } from 'apollo-client';

const update = (
  variables: DeletePageVariables,
): MutationUpdaterFn<DeletePagePayload> => (cache, { data }) => {
  const query = cache.readQuery<ListPagesData>({
    query: LIST_PAGES_QUERY,
  });
  if (data && query) {
    const {
      pages: { edges },
    } = query;
    const updatedEdges = edges.filter(edge => edge.node.id !== variables.id);
    cache.writeQuery<ListPagesData>({
      query: LIST_PAGES_QUERY,
      data: { ...query, pages: { ...query.pages, edges: updatedEdges } },
    });
  }
};

export const useDeletePageMutation = (
  variables: DeletePageVariables,
  options?: Omit<MutationHookOptions, 'mutation' | 'variables'>,
) =>
  useMutation<DeletePagePayload, DeletePageVariables>(DELETE_PAGE_MUTATION, {
    variables,
    update: update(variables),
    ...options,
  });
